import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import LabelsTableHeader from '@SiteComponents/LabelsTableHeader'
import LabelsTableList from './LabelsTableList'

import {
  openCreateLabelPopup,
  openDeleteLabelPopup,
  openRenameLabelPopup,
} from '@SiteModules/Popup/actions'

import {
  getCurrentWorkspaceName,
} from '@SiteModules/Workspace/selectors'

import {
  getLabels,
} from '@SiteModules/Label/selectors'

import {
  getCurrentAccountAvailableTotalCredits,
} from '@SiteModules/Account/selectors'

import {
  IOpenDeleteLabelPopupPayload,
  IOpenRenameLabelPopupPayload,
} from '@SiteModules/Popup/types'

import './LabelsTable.scss'

const LabelsTable: React.FC = () => {
  const dispatch = useDispatch()

  const currentWorkspaceName = useSelector(getCurrentWorkspaceName)
  const availableTotalCredits = useSelector(getCurrentAccountAvailableTotalCredits)
  const labels = useSelector(getLabels)
  const totalCountOfLabels = labels.length

  const handleOpenCreateLabelPopup = () => {
    dispatch(openCreateLabelPopup())
  }

  const handleOpenDeleteLabelPopup = (payload: IOpenDeleteLabelPopupPayload) => {
    dispatch(openDeleteLabelPopup(payload))
  }

  const handleOpenRenameLabelPopup = (payload: IOpenRenameLabelPopupPayload) => {
    dispatch(openRenameLabelPopup(payload))
  }

  return (
    <div className="LabelsTable">
      <div className="LabelsTable__main">
        <LabelsTableHeader
          currentWorkspaceName={currentWorkspaceName}
          totalCountOfLabels={totalCountOfLabels}
          availableTotalCredits={availableTotalCredits}
          handleOpenCreateLabelPopup={handleOpenCreateLabelPopup}
        />
        <LabelsTableList
          labels={labels}
          openDeleteLabelPopup={handleOpenDeleteLabelPopup}
          openRenameLabelPopup={handleOpenRenameLabelPopup}
        />
      </div>
    </div>
  )
}

export default LabelsTable
